import { apiClient } from "./client";

export type HomePractitioner = {
  id: string;
  last_name: string;
  first_name: string | null;
  first_initial: string | null;
  rpps: string | null;
  display_name: string;
};

export type UpcomingShift = {
  assignment_id: string;
  date: string;
  slot_label: string;
  slot_start: string;
  slot_end: string;
  is_cancelled: boolean;
};

export type ExpiringDoc = {
  document_id: string;
  kind: string;
  label: string;
  expires_at: string;
  days_until_expiry: number;
};

export type HomePayload = {
  is_practitioner: boolean;
  practitioner: HomePractitioner | null;
  organization_count: number;
  month_shifts: number;
  month_hours: number;
  month_weighted_hours: number;
  year_shifts: number;
  year_hours: number;
  incoming_swap_proposals: number;
  open_coverage_requests: number;
  expiring_documents: number;
  upcoming_shifts: UpcomingShift[];
  expiring_documents_sample: ExpiringDoc[];
};

export async function getMyHome(): Promise<HomePayload> {
  const { data } = await apiClient.get<HomePayload>("/api/v1/me/home");
  return data;
}
